import OrbAvatar from "./orb-avatar";

export default OrbAvatar;
